const removeEmptyTrendingMomentum = () => {
    document
        .querySelectorAll('.ff-discovery-trending-momentum')
        .forEach((momentum) => {
            const hasSocialSignal = momentum.querySelector(
                '.ff-festival-social-context > *, .ff-discovery-trending-momentum-copy',
            );

            if (!hasSocialSignal) {
                momentum.remove();
            }
        });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeEmptyTrendingMomentum, {
        once: true,
    });
} else {
    removeEmptyTrendingMomentum();
}
